import clsx from 'clsx'
import React from 'react'

import { PAYMENT_PROGRESS_BAR_DISPLAY_NAME, SIZES } from './constants'
import { PaymentProgressProps } from './PaymentProgress'
import styles from './style.module.scss'
import { calcPercent } from './utils'

export const Bar = React.forwardRef<HTMLDivElement, PaymentProgressProps>(
  ({ size = SIZES.LARGE, step = 2, maxStep = 4, testNameSpace = '', ...otherProps }, ref): JSX.Element => {
    const percentage = calcPercent(step, maxStep)
    const barClassNames = clsx(styles.progressBar, styles[`progressBarSize${size}`])

    return (
      <div {...otherProps} ref={ref} role='progressbar' aria-valuemax={100} aria-valuemin={0} aria-valuenow={percentage} className={barClassNames}>
        <div className={styles.innerBarBg}>
          <div
            className={styles.innerBar}
            style={{
              width: `${percentage}%`,
            }}
            {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-inner-bar` })}
          ></div>
        </div>
      </div>
    )
  }
)

Bar.displayName = PAYMENT_PROGRESS_BAR_DISPLAY_NAME
